import { AllWriterTable } from './AllWriterTable'
import { withAllWriterTable } from './withAllWriterTable'

const Connected = withAllWriterTable(AllWriterTable)

export { Connected as AllWriterTable }
